import { useSelector } from 'react-redux';
import Modal from '../../../../new-components/mobile/Modal';
import OfferDetails from './OfferDetails';
import { useTranslation } from 'next-i18next';
import { useState } from 'react';
import { EntityTypes } from '../../../../new-lib/constants/common';
import styled from 'styled-components';
import { CompoundOffer } from '../../dtos';
import OffersCTA from './entity-cards/OffersCTA';
import UpArrowIcon from '../../../../public/assets/icons/common/UpArrow';

interface OfferModalProps {
  isOpen: boolean;
  handleClose: () => void;
  offer: CompoundOffer;
  renderOfferDetails: (
    offer: CompoundOffer,
    closeModal: boolean
  ) => JSX.Element;
}

const OfferModal = ({
  isOpen,
  offer,
  handleClose,
  renderOfferDetails
}: OfferModalProps) => {
  const isMobile = useSelector((state: any) => state.app.isMobile);
  const { t } = useTranslation(['cityscape', 'common']);
  const [showOffers, setShowOffers] = useState(true);

  const showMoreOffers = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.stopPropagation();
    setShowOffers(!showOffers);
  };

  return (
    <Modal
      isOpen={isOpen && !isMobile}
      closeFn={handleClose}
      modalWidth={'529px'}
      modalHeight={undefined}
      fullscreen={true}
      withCloseBtn
    >
      <div className="offer-modal-content">
        {renderOfferDetails(offer, false)}
        {showOffers && (
          <>
            {offer?.compound_offers
              ?.slice(1)
              .map((additionalOffer: any, index: number) => (
                <OfferDetails
                  modalOpen={isOpen}
                  offer={additionalOffer}
                  index={index + 1}
                  key={index}
                />
              ))}
          </>
        )}

        {offer.compound_offers.length > 1 && (
          <div className="more-offers modal" onClick={e => showMoreOffers(e)}>
            <span>
              {showOffers ? (
                <>
                  {t('See Less', { ns: 'common' })}
                  <span className={`icon-arrow`}>
                    <UpArrowIcon />
                  </span>
                </>
              ) : (
                <>
                  {`${offer.compound_offers.length - 1} ${
                    offer.compound_offers.length > 2
                      ? t('more_offers')
                      : t('more_offer')
                  }`}
                  <span className={`icon-arrow rotated`}>
                    <UpArrowIcon />
                  </span>
                </>
              )}
            </span>
          </div>
        )}
        <CTAWrapper>
          <OffersCTA
            clickEventData={{
              eventAction: 'offer_click',
              eventLocation: 'CityScape_Offers',
              featureName: 'offers'
            }}
            offer={offer}
            entityType={EntityTypes.COMPOUND}
            closeModal={false}
          />
        </CTAWrapper>
      </div>
    </Modal>
  );
};

const CTAWrapper = styled.div`
  width: 100%;
  display: flex;
  position: sticky;
  bottom: 0;
  background-color: white;
  padding: 4px 0px 16px 0px;
  .btns-container {
    width: 100%;
    display: flex;
    gap: 8px;
    button {
      border-radius: 10px !important;
      width: 100%;
    }
    a {
      width: 100%;

      button {
        border: 1px solid #c6d0de;
        background-color: white !important;
        color: black;
        svg {
          display: none;
        }
      }
    }
    > div {
      width: 100%;
    }
  }
`;

export default OfferModal;
